import { FileEdit } from "lucide-react";

import {
  AgentApprovalBatchCard,
  type ApprovalRow,
} from "./AgentApprovalBatchCard";

type SkillApproval = {
  appointment_id: number;
  contact_id: number;
  contact_label: string;
  approval_id: string;
  summary: string;
};

export const PostMeetingRecapCard = () => (
  <AgentApprovalBatchCard<SkillApproval>
    title="CR post-visio à valider"
    description="Pour chaque RDV passé < 48h sans note, l'IA propose un compte-rendu + une tâche de suivi. Valide / modifie / refuse pour chaque."
    icon={FileEdit}
    iconClass="text-fabrik-blue"
    ctaLabel="Analyser les visios récentes"
    emptyLabel="Aucun RDV récent à documenter."
    skillId="post_meeting_recap_proposal"
    skillInput={{ hours_back: 48, limit: 10 }}
    approveSuccessLabel="Enregistré"
    toRow={(
      a,
    ): Pick<ApprovalRow, "approval_id" | "contact_label" | "subtitle"> => ({
      approval_id: a.approval_id,
      contact_label: a.contact_label,
      subtitle: a.summary,
    })}
    extractBody={(payload) => ({
      body: (payload.note_text as string | undefined) ?? "(compte-rendu vide)",
      subtitle: undefined,
    })}
    applyEdits={(payload, _subtitle, body) => ({
      ...payload,
      note_text: body,
    })}
  />
);
